module.exports = __webpack_public_path__ + "img/broadbandOfferLarge.png";